<template>
  <p v-if="visible" class="login-hint">
    Войдите в аккаунт, чтобы видеть ответы и историю заявок в разделе «Мои запросы».
  </p>
</template>

<script setup>
import { UserService } from "~/services/UserService";

// Подсказка только для гостя: авторизованному клиенту заявка сразу попадает в его «Мои запросы».
const visible = ref(false);

onMounted(async () => {
  try {
    const user = await UserService.getInstance().getCurrent();
    visible.value = !user;
  } catch {
    visible.value = true;
  }
});
</script>

<style scoped>
.login-hint {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #3a3330;
  opacity: 0.8;
}
</style>
